import { resolveJsonata } from '@the-platform-company/jsonata-utilities'
import { isPlainObject } from 'lodash-es'
import { State, Store } from './types'

export const resolveActionProps = ({
  store,
  state,
  props,
  actions,
  path = '',
}: {
  store: Store
  state: State
  props: unknown
  actions: string[]
  path?: string
}): unknown => {
  if (isPlainObject(props)) {
    return Object.fromEntries(
      Object.entries(props as Record<string, unknown>).map(([k, v]) => [
        k,
        resolveActionProps({
          store,
          state,
          props: v,
          actions,
          path: path ? `${path}.${k}` : k,
        }),
      ])
    )
  }

  if (Array.isArray(props)) {
    return props.map((item) =>
      resolveActionProps({
        store,
        state,
        props: item,
        actions,
        path: path ? `${path}.items` : 'items',
      })
    )
  }

  if (actions.includes(path)) {
    if (typeof props === 'string') {
      return resolveJsonata(props, state)
    }

    if (typeof props === 'function') {
      const fn = props as (store: Store, ...params: unknown[]) => void

      return (...params: unknown[]) => fn(store, ...params)
    }
  }

  return props
}
